import { shallowRef, triggerRef, type ShallowRef } from "vue";

export class LibLoader {
	static async loadCore() {
		return (await google.maps.importLibrary("core")) as google.maps.CoreLibrary;
	}

	static async loadMaps() {
		return (await google.maps.importLibrary("maps")) as google.maps.MapsLibrary;
	}

	static async loadMarker() {
		return (await google.maps.importLibrary("marker")) as google.maps.MarkerLibrary;
	}
}

export const LibTypes = {
	core: "core",
	maps: "maps",
	marker: "marker",
} as const;
export type LibTypes = (typeof LibTypes)[keyof typeof LibTypes];

type InferLib<T extends LibTypes> = T extends "core"
	? google.maps.CoreLibrary
	: T extends "maps"
		? google.maps.MapsLibrary
		: T extends "marker"
			? google.maps.MarkerLibrary
			: never;

export function useLib<T extends LibTypes>(lib: T): ShallowRef<InferLib<T> | undefined> {
	const libRef = shallowRef<InferLib<T>>();

	let call: Promise<InferLib<T>> | undefined = undefined;
	switch (lib) {
		case LibTypes.core:
			call = LibLoader.loadCore() as any;
			break;
		case LibTypes.maps:
			call = LibLoader.loadMaps() as any;
			break;
		case LibTypes.marker:
			call = LibLoader.loadMarker() as any;
			break;
	}

	if (!call) {
		throw new Error("Invalid lib type");
	}

	call.then((value) => {
		libRef.value = value;
		triggerRef(libRef);
	});

	return libRef;
}
